import React from 'react';
import SvgConcentric from '../../asset/img/svg/svg-concentric';
import DetectDevice from "../../utils/detectDevice";

const Section5 = () => {
  const { mobile } = DetectDevice();
  const [paddingValTop, setPaddingValTop] = React.useState(200);
  const [paddingValBtm, setPaddingValBtm] = React.useState(100);

  React.useEffect(() => {
    mobile ? setPaddingValTop(40) : setPaddingValTop(140);
    mobile ? setPaddingValBtm(400) : setPaddingValBtm(200);
  }, [mobile]);

  return (
    <div className="section-5 d-flex flex-column align-items-center">
      <div style={{
        marginTop: paddingValTop,
        marginBottom: paddingValBtm,
      }}>
        <div className='d-flex justify-content-center align-items-center z-0'>
          <SvgConcentric />
          <div className="d-flex justify-content-center align-items-center section-text z-1
            card py-5 px-4 mx-lg-0 mx-2">
            <div className="fw-medium text-center section-text-heading mb-3 mb-lg-5">
              Optimized | Better Security | Low Cost
            </div>
            <div className='d-flex flex-column flex-lg-row gap-4'>
              {/* First Card */}
              <div className='sub-card'>
                <div className="sub-card-heading fw-bold mb-2">Optimized</div>
                <div className="sub-card-subheading">Enhanced efficiency and streamlined workflows to maximize performance.</div>
              </div>
              
              {/* Second Card */}
              <div className='sub-card'>
                <div className="sub-card-heading fw-bold mb-2">Better Security</div>
                <div className="sub-card-subheading">Robust protection measures to safeguard your data and prevent breaches.</div>
              </div>
              
              {/* Third Card */}
              <div className='sub-card'>
                <div className="sub-card-heading fw-bold mb-2">Low Cost</div>
                <div className="sub-card-subheading">Cost-effective solutions that deliver value without compromising quality.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section5;
